import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()
const AREAS="areas"
const AREAS_MANAGER="areas/manager"

export const AreasGet = (params) => {
	const controller= loadAbort()
	const call= axios.get(AREAS,{params,signal:controller.signal})
	return {call,controller}
}
export const AreasManagerGet = (params) => {
	const controller= loadAbort()
	const call= axios.get(AREAS_MANAGER,{params,signal:controller.signal})
	return {call,controller}
}
export const DepartamentoManagerGet = (params) => {
	const controller= loadAbort()
	const call= axios.get(AREAS_MANAGER,{params,signal:controller.signal})
	return {call,controller}
}